<div class="contracts-dashboard">
  <div class="header">
    <div class="title-section">
      <h2>{{componentTitle}}</h2>
    </div>
    <div class="search-bar-container">
      <div class="search-child">
        <emerald-input
          [label]="'Search'"
          [trailingIcon]="'search'"
          (keyup)="searchContracts($event)"
          [value]="filterValue"
        >
          <emerald-icon
            *ngIf="filterValue?.length && filterValue.length > 0"
            [icon]="'close'"
            (click)="clearInput()"
          ></emerald-icon>
        </emerald-input>
      </div>
    </div>
  </div>

  <div class="datatable-container">
    <ng-container *ngIf="filteredContractors?.length; else noDataTemplate">
      <emerald-datatable
        [columnDefs]="columnDefs"
        [rowData]="filteredContractors"
        [paginationParams]="paginationParams"
        [maxHeight]="maxTableHeight"
        [customCellTemplate]="{
          numberOfDaysLeft: customDaysLeftColumn,
          action: customActionColumn
        }"
      >
      </emerald-datatable>
    </ng-container>
    <ng-template #customDaysLeftColumn let-eachRow="eachRow">
  <span
    [ngClass]="{
      'days-left-red': eachRow.numberOfDaysLeft <= 30,
      'days-left-amber': eachRow.numberOfDaysLeft > 30 && eachRow.numberOfDaysLeft <= 60,
      'days-left-yellow': eachRow.numberOfDaysLeft > 60 && eachRow.numberOfDaysLeft <= 90
    }"
  >
    {{ eachRow.numberOfDaysLeft }} Days
  </span>
</ng-template>
    <ng-template #noDataTemplate>
      <section class="records-container" aria-label="Records section">
        <div class="empty-state">
          <h2 class="empty-state-title">{{noDataMessage}}</h2>
          <img
            [src]="imageSrc"
            alt={{altText}}
            class="empty-state-image"
          />
        </div>
      </section>
    </ng-template>
    <ng-template #customActionColumn let-eachRow="eachRow">
        <img
          src="assets/img/notificationmultiple.svg"
          alt="Notify"
          class="notify-icon"
        />
    </ng-template>
  </div>
</div>